import { render, staticRenderFns } from "./article_content.vue?vue&type=template&id=1886e82d&"
import script from "./article_content.vue?vue&type=script&lang=js&"
export * from "./article_content.vue?vue&type=script&lang=js&"
import style0 from "./article_content.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports